import { usePage } from '@inertiajs/react';

export const useAsset = () => {
    const { assetUrl } = usePage().props;
    const base = (assetUrl ?? '').replace(/\/$/, '');

    return (path: string): string => {
        const fullPath = `/assets/${path.replace(/^\//, '')}`;
        return base ? `${base}${fullPath}` : fullPath;
    };
};
